// models/produtos/Marca.js
export class Marca {
    constructor(id = 0, descricao = '') {
        this.id = id;
        this.descricao = descricao;
    }
}
